import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useFileDropzoneStyles = makeStyles({
  dropzone: {
    border: `1px solid ${designTokens.neutral[200]}`,
    borderRadius: designTokens.borderRadius.md,
    padding: `${designTokens.spacing[3]} ${designTokens.spacing[4]}`,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: designTokens.spacing[3],
    height: "44px",
    cursor: "pointer",
    transition: `all ${designTokens.transition.fast}`,
    backgroundColor: designTokens.neutral[50],

    ":hover": {
      border: `1px solid ${designTokens.accent[500]}`,
      backgroundColor: designTokens.accent[50],
    },

    ":focus-visible": {
      outlineStyle: "solid",
      outlineWidth: "2px",
      outlineColor: designTokens.accent[500],
      outlineOffset: "2px",
    },
  },

  dropzoneActive: {
    border: `1px solid ${designTokens.accent[500]}`,
    backgroundColor: designTokens.accent[50],
  },

  dropzoneDisabled: {
    cursor: "not-allowed",
    opacity: 0.6,

    ":hover": {
      border: `1px solid ${designTokens.neutral[200]}`,
      backgroundColor: designTokens.neutral[50],
    },
  },

  icon: {
    fontSize: "20px",
    color: designTokens.accent[500],
    flexShrink: 0,
  },

  acceptedTypesLabel: {
    opacity: 0.6,
  },

  fileInput: {
    display: "none",
  },
});
